const DEFAULT_BRAND_NAME = 'Chatwoot';

export const getInstanceBrandName = config => {
  const sourceConfig =
    config ||
    (typeof window !== 'undefined' ? window.globalConfig : undefined) ||
    {};

  return (
    sourceConfig.BRAND_NAME ||
    sourceConfig.brandName ||
    sourceConfig.INSTALLATION_NAME ||
    sourceConfig.installationName ||
    DEFAULT_BRAND_NAME
  );
};

export const replaceDefaultBrandName = (
  text,
  brandName = getInstanceBrandName()
) => {
  if (typeof text !== 'string' || !text) return text;
  if (!brandName || brandName === DEFAULT_BRAND_NAME) return text;

  return text.replace(/\bChatwoot\b/g, brandName);
};
